"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 6.7A3.7 3.7 0 0 1 6.7 3h6.6A3.7 3.7 0 0 1 17 6.7v6.6a3.7 3.7 0 0 1-3.7 3.7H6.7A3.7 3.7 0 0 1 3 13.3zm3.7-2.3a2.3 2.3 0 0 0-2.3 2.3v6.6a2.3 2.3 0 0 0 2.3 2.3h6.6a2.3 2.3 0 0 0 2.3-2.3V6.7a2.3 2.3 0 0 0-2.3-2.3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.579 11.82c-1.028.242-1.846.59-2.367 1.005L3.34 11.73c.75-.597 1.792-1.008 2.919-1.273 1.138-.267 2.418-.398 3.687-.398 1.27 0 2.55.13 3.688.398 1.127.265 2.17.676 2.92 1.273l-.872 1.095c-.522-.415-1.34-.764-2.368-1.005-1.017-.239-2.187-.361-3.368-.36-1.18 0-2.35.121-3.367.36",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.148 7.485a.835.835 0 1 1-1.67 0 .835.835 0 0 1 1.67 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ImageIcon20.js.map